import React from 'react';

/**
 * ClearSelectionButtonコンポーネントのプロパティ
 */
interface ClearSelectionButtonProps {
  /** 選択をクリアする時に呼び出されるコールバック */
  onClear: () => void;
  /** trueの場合、ボタンを表示 */
  hasSelection: boolean;
  /** 追加のCSSスタイル */
  style?: React.CSSProperties;
}

/**
 * グラフコンポーネント用の選択解除ボタン
 * アクティブな選択がある場合のみ表示されます。
 *
 * @example
 * ```tsx
 * <ClearSelectionButton
 *   onClear={() => setSelection([])}
 *   hasSelection={selection.length > 0}
 * />
 * ```
 */
export function ClearSelectionButton({ onClear, hasSelection, style }: ClearSelectionButtonProps) {
  if (!hasSelection) return null;

  return (
    <button
      onClick={onClear}
      title="Clear selection"
      style={{
        width: '28px',
        height: '28px',
        padding: '0',
        border: 'none',
        borderRadius: '4px',
        background: 'transparent',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
        ...style
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255, 0, 0, 0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      {/* クリアアイコン（×マーク） */}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path 
          d="M4 4L12 12M12 4L4 12" 
          stroke="#6c757d" 
          strokeWidth="2" 
          strokeLinecap="round" 
        />
      </svg>
    </button>
  );
}